"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const callableToggleBottomMenu = ({ entryVars: { close: shouldOnlyClose, }, callbacks, executeProcesses, processor, }) => {
    if (processor.root.getIsBottomMenuOpened()) {
        processor.root.setIsBottomMenuOpened(false);
    }
    else if (!shouldOnlyClose) {
        processor.root.setIsBottomMenuOpened(true);
    }
    executeProcesses(undefined, callbacks.successProcess);
};
exports.default = callableToggleBottomMenu;
